import {EventEmitter, Injectable} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {ProfileService} from '../../../auth/services/profile.service';
import {filter, map} from 'rxjs/operators';
import {PartnerService} from './services/partner.service';
import {AdminService} from './services/admin.service';
import {DashboardCounters} from '../../../models/dashboardCounters.model';
import {NotifificationService as NotificationService} from '../../../../services/notification.service';
import {SupportService} from "../../../../services/support.service";
import {Title} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root',
})
export class ControlPanelService {
  private _currentPage: string = 'Dashboard';

  private routePageMap: { [key: string]: string } = {
    dashboard: 'Dashboard',
    quotes: 'Quotes', 'quote-details': 'Quote Details',
    clinics: 'Clinics', 'contact-requests': 'Contact Requests',
    leads: 'Leads', 'quote-requests': 'Quote Requests',
    users: 'Users',
    notifications: 'Notification Settings',
    verification: 'Verification', 'account-update': 'Clinic Details',
    settings: 'Account',
    reviews: 'Reviews',
    'qr-codes': 'QR Codes',
    interest: 'Interest in quotes',
  };

  countersReady = new EventEmitter<boolean>();

  dashboardCounters?: DashboardCounters;

  constructor(
    private profileService: ProfileService,
    private partnerService: PartnerService,
    private supportService: SupportService,
    private adminService: AdminService,
    private router: Router,
    private notifiationService: NotificationService,
    private title: Title
  ) {
    this.notifiationService.init();
    this.initializeRouteListener();
    // Aggiorna i badge della sidebar in realtime quando il partner compie un'azione che
    // cambia lo stato di una richiesta (accept/reject/unlock/acquire): PartnerService emette
    // onRequestsUpdated su ognuna. Senza questo, il contatore "new" resterebbe fermo fino al reload.
    this.partnerService.onRequestsUpdated.subscribe(() => this.getCounters());
  }

  get currentPage(): string {
    return this._currentPage;
  }

  get isAdminUser(): boolean {
    return this.profileService.isAdmin;
  }

  set currentPageName(name: string) {
    setTimeout(() => {
      this._currentPage = name;
      this.title.setTitle(`Dental Tour - ${name}`);
    }, 10);
  }

  private initializeRouteListener(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map((event) => event as NavigationEnd)
      )
  }

  clearCounters(): void {
    this.dashboardCounters = undefined;
  }

  async getCounters(): Promise<DashboardCounters | undefined> {

    const isAdmin = this.profileService.isAdmin;
    const isSupport = this.profileService.isSupport;
    if (isAdmin) {
      await this.getAdminCounters();
    } else if (isSupport) {
      await this.getSupportLeadCounters();
    } else {
      await this.getPartnerCounters();
    }

    this.countersReady.emit(true);
    return this.dashboardCounters;
  }

  async getAdminCounters() {
    try {
      this.dashboardCounters = await this.adminService.getCounters();
    } catch (error) {
      console.error('Error loading admin counters:', error);
      this.dashboardCounters = undefined;
    }
  }

  async getPartnerCounters() {
    try {
      this.dashboardCounters = await this.partnerService.getCounters();
    } catch (error) {
      console.error('Error loading partner counters:', error);
      this.dashboardCounters = undefined;
    }
  }


  async getSupportLeadCounters() {
    try {
      this.dashboardCounters = await this.supportService.getCounters();
    } catch (error) {
      console.error('Error loading support counters:', error);
      this.dashboardCounters = undefined;
    }
  }
}
